import React from 'react';

interface InputNumberProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> {
	value: number | string;
	onChange: (value: number | string) => void;
	max?: number;
	min?: number;
	round?: boolean;
	fractionDigits?: number;
	preventBlurOnWheel?: boolean;
}

const InputNumber: React.FC<InputNumberProps> = ({
	value, fractionDigits = 2, onChange, round, max = 100, min = 0, ...rest
}) => {
	const handleWheel = (e) => {
		rest.onWheel && rest.onWheel(e);
		!rest.preventBlurOnWheel && e.currentTarget.blur();
	};

	return (
		<input
			className="form-control"
			step="any"
			{...rest}
			type="number"
			value={value}
			onWheel={handleWheel}
			onChange={(e) => {
				const value = +e.target.value || 0;

				if (value >= min && value <= max) {
					const hasInputType = (e.nativeEvent as any).inputType;

					const res = e.target.value
						.replace(/^0+([1-9.,])/, (value, $1) => (value.includes(',') || value.includes('.') ? '0.' : $1))
						.replace(
							/[.,]\d+/,
							(str) => str.slice(0, round || +((!hasInputType && rest.step) || 0) > 1 ? 0 : 3),
						);

					onChange((e.nativeEvent as any).data === '.' ? e.target.value : res);
				}
			}}
		/>
	);
};

export default InputNumber;
